// getter
export const GETTERS_LIST_PERMISSIONS = "GETTERS_LIST_PERMISSIONS";
export const GETTERS_PERMISSION_PAGINATION = "GETTERS_PERMISSION_PAGINATION";
export const GETTERS_PERMISSION_DETAIL = "GETTERS_PERMISSION_DETAIL";

// action
export const ACTION_GET_PERMISSION_LIST = "ACTION_GET_PERMISSION_LIST";
export const ACTION_GET_CLIENT_ADMIN_PERMISSION_LIST =
  "ACTION_GET_CLIENT_ADMIN_PERMISSION_LIST";
export const ACTION_ADD_PERMISSION = "ACTION_ADD_PERMISSION";
export const ACTION_EDIT_PERMISSION = "ACTION_EDIT_PERMISSION";
export const ACTION_GET_PERMISSION_DETAIL = "ACTION_GET_PERMISSION_DETAIL";
export const ACTION_SET_EMPTY_PERMISSION = "ACTION_SET_EMPTY_PERMISSION";

// mutation
export const MUTATION_SET_PERMISSION_LIST = "MUTATION_SET_PERMISSION_LIST";
export const MUTATION_SET_PERMISSION = "MUTATION_SET_PERMISSION";

export const READ = "index";
export const WRITE = "store";
export const EDIT = "update";
export const DELETE = "destroy";
export const VIEW_DETAIL = "update";
export const FORCE_DELETE = "force_delete";



// WEBPACK FOOTER //
// ./src/store/modules/permissions/constants.js